import baseAPI from '@/api/base';
import {
  EditLeaveLedger,
  GetLeaveLedger,
  RegisterLeaveLedger,
} from '@/dtos/leave_ledger.dto';
import {
  DELETE_LEAVE_LEDGER_URL,
  EDIT_LEAVE_LEDGER_URL,
  GET_LEAVE_LEDGER_URL,
  GET_LEAVE_LEDGERS_URL,
  REGISTER_LEAVE_LEDGER_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class LeaveLedger {
  static getLeaveLedgers = async (
    getLeaveLedger: GetLeaveLedger
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_LEAVE_LEDGERS_URL, {
      params: getLeaveLedger,
    });
    return response;
  };

  static getLeaveLedger = async (
    getLeaveLedger: GetLeaveLedger
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_LEAVE_LEDGER_URL, {
      params: getLeaveLedger,
    });
    return response;
  };

  static registerLeaveLedger = async (
    registerLeaveLedger: RegisterLeaveLedger
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_LEAVE_LEDGER_URL,
      { ...registerLeaveLedger }
    );
    return response;
  };

  static editLeaveLedger = async (
    editLeaveLedger: EditLeaveLedger
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_LEAVE_LEDGER_URL, {
      ...editLeaveLedger,
    });
    return response;
  };

  static deleteLeaveLedger = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_LEAVE_LEDGER_URL}/${id}`
    );
    return response;
  };
}

export default LeaveLedger;
